module.exports = __webpack_public_path__ + "static/media/service_1.4ddcc5cf.png";